import { useEffect, useState } from 'react';
import { Textarea } from '@ui/src';
import { Controller } from 'react-hook-form';
import { AnnualIncomesTypes } from '../../types';
import InfoRow from '../../info-row';
import { NewApplicationStatus } from '../../../../hoc/new-application/types';
import AnnualIncome from './annual-income';

import cn from '../../new-application.module.css';

const AnnualIncomes = ({
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  status,
  isEditable,
  questionnarieSetValue,
  questionnarieFields,
  annualIncomes,
  totalIncomeError,
  setTotalIncomeError,
}: AnnualIncomesTypes) => {
  const [totalPercent, setTotalPercent] = useState(0);

  const otherAnnualIncome = annualIncomes?.find((item) =>
    item.value?.includes('Other'),
  );

  useEffect(() => {
    if (questionnarieFields && annualIncomes) {
      if (questionnarieFields?.sourcesOfAnnualIncomes?.length) {
        let percentValues = 0;

        questionnarieFields?.sourcesOfAnnualIncomes?.forEach((item) => {
          percentValues += Number(item.percentage);
        });

        if (percentValues > 100) {
          setTotalIncomeError('Source of annual income in % more than 100%');
        } else {
          setTotalIncomeError('');
        }

        setTotalPercent(percentValues);
      }
    }
  }, [questionnarieFields, annualIncomes]);

  useEffect(() => {
    if (
      annualIncomes &&
      questionnarieFields?.sourcesOfAnnualIncomesOther &&
      !Number(
        questionnarieFields?.sourcesOfAnnualIncomes?.find(
          (item) => item.sourceOfAnnualIncomeId === otherAnnualIncome?.id,
        )?.percentage,
      )
    ) {
      questionnarieClearErrors(['sourcesOfAnnualIncomesOther']);
      questionnarieSetValue('sourcesOfAnnualIncomesOther', '');
    }
  }, [
    questionnarieFields?.sourcesOfAnnualIncomesOther,
    questionnarieFields?.sourcesOfAnnualIncomes,
    annualIncomes,
  ]);

  return (
    <div className={cn.annualIncomesWrapper}>
      <div className={cn.annualIncomesTitle}>
        Source of annual income in %:{' '}
        <span>Total must equal 100% (currently {totalPercent}%)</span>
      </div>
      {totalIncomeError && (
        <div className={cn.totalError}>{totalIncomeError}</div>
      )}
      {questionnarieErrors?.sourcesOfAnnualIncomes?.message && (
        <div className={cn.totalError}>
          {questionnarieErrors?.sourcesOfAnnualIncomes?.message}
        </div>
      )}
      <div className={cn.annualIncomeList}>
        {annualIncomes?.map((item) => (
          <AnnualIncome
            key={item.id}
            id={item.id}
            name={item.value}
            questionnarieClearErrors={questionnarieClearErrors}
            isEditable={isEditable}
            status={status}
            annualIncomesValues={questionnarieFields?.sourcesOfAnnualIncomes}
            questionnarieSetValue={questionnarieSetValue}
            annualIncomesValue={questionnarieFields?.sourcesOfAnnualIncomes?.find(
              (sourcesOfAnnualIncome) =>
                sourcesOfAnnualIncome.sourceOfAnnualIncomeId === item.id,
            )}
          />
        ))}
        {annualIncomes &&
          Number(
            questionnarieFields?.sourcesOfAnnualIncomes?.find(
              (item) => item.sourceOfAnnualIncomeId === otherAnnualIncome?.id,
            )?.percentage,
          ) > 0 && (
            <InfoRow
              title="Other income"
              id="sourcesOfAnnualIncomesOther"
              className={cn.noFlex}
              lessPadding
            >
              <Controller
                control={questionnarieControl}
                name="sourcesOfAnnualIncomesOther"
                defaultValue=""
                render={({ field: { onChange, value, name } }) => (
                  <Textarea
                    name={name}
                    title=""
                    placeholder="Describe income..."
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      questionnarieClearErrors(['sourcesOfAnnualIncomesOther']);
                    }}
                    className={`borderless ${cn.pepTextarea} ${cn.stepOneTextarea}`}
                    error={
                      questionnarieErrors?.sourcesOfAnnualIncomesOther?.message
                    }
                    tabIndex={
                      !isEditable &&
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                        ? -1
                        : 0
                    }
                    disabled={
                      !isEditable ||
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                    }
                  />
                )}
              />
            </InfoRow>
          )}
      </div>
      <Controller
        control={questionnarieControl}
        name="sourcesOfAnnualIncomes"
        defaultValue={[]}
        render={({ field: { name } }) => <input type="hidden" name={name} />}
      />
    </div>
  );
};

export default AnnualIncomes;
